import Icon from './Icon.jsx';
import s from './IconButton.module.css';

export default function IconButton({ icon, label, className = '', ...rest }) {
  return (
    <button type="button" aria-label={label} className={`${s.iconBtn} ${className}`.trim()} {...rest}>
      <Icon name={icon} size="md" />
    </button>
  );
}
